import React, { useEffect, useState } from "react";
import { getCsrfToken } from "../../../../public/api/authApi";
import { GlobalModal } from "../../../../global/GlobalModal";
import { GlobalButton, GlobalTextField } from "../../../../global/forms/GlobalFormFields";
import { markVisitorExit } from "../../api/visitorsApi";
import { ensureCsrfToken, getCurrentTimeString } from "../../utils/visitorHelpers";
import { notifyVisitorDataChanged } from "../../utils/visitorDataEvents";

export default function ExitVisitorModal({ visitor, onClose, onSuccess }) {
  const open = Boolean(visitor?.id);
  const [outTime, setOutTime] = useState(() => getCurrentTimeString());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [fieldError, setFieldError] = useState("");

  useEffect(() => {
    if (visitor?.id) {
      setOutTime(getCurrentTimeString());
      setError("");
      setFieldError("");
    }
  }, [visitor?.id]);

  const handleConfirm = async () => {
    if (!visitor?.id) return;
    setLoading(true);
    setError("");
    setFieldError("");
    try {
      const csrfToken = await ensureCsrfToken(getCsrfToken);
      await markVisitorExit(
        visitor.id,
        outTime ? { out_time: outTime } : {},
        csrfToken,
      );
      notifyVisitorDataChanged();
      onSuccess?.("Visitor exit marked successfully");
      onClose?.();
    } catch (err) {
      const details = err?.details || {};
      if (details.out_time) setFieldError(details.out_time);
      else setError(err?.message || "Failed to mark exit");
    } finally {
      setLoading(false);
    }
  };

  return (
    <GlobalModal
      open={open}
      onClose={onClose}
      title="Mark visitor exit"
      size="sm"
      closeOnBackdrop={!loading}
      footer={
        <div style={{ display: "flex", gap: "0.5rem", justifyContent: "flex-end", width: "100%" }}>
          <GlobalButton variant="ghost" onClick={onClose} disabled={loading}>
            Cancel
          </GlobalButton>
          <GlobalButton variant="primary" onClick={handleConfirm} disabled={loading}>
            {loading ? "Saving…" : "Confirm exit"}
          </GlobalButton>
        </div>
      }
    >
      {error ? (
        <p className="gfb-feedback gfb-feedback--error" role="alert">
          {error}
        </p>
      ) : null}
      <p style={{ fontSize: "0.9375rem", color: "#475569", marginBottom: "1rem" }}>
        Record exit for <strong>{visitor?.visitor_name}</strong>
        {visitor?.visitor_code ? ` (${visitor.visitor_code})` : ""}.
      </p>
      <GlobalTextField
        id="exit-out-time"
        label="Out time"
        type="time"
        value={outTime}
        onChange={setOutTime}
        error={fieldError}
      />
    </GlobalModal>
  );
}
